import state from './modulePropertyState.js'
import mutations from './modulePropertyMutations.js'
import actions from './modulePropertyActions.js'
import getters from './modulePropertyGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
